import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { FEATURE_MEETING_MICROSOFT_TEAMS_TOKEN } from '../../data-providers/providers';
import { Observable } from 'rxjs';

@Component({
  selector: 'meeting-scheduler-settings-calendar-card',
  templateUrl: './calendar-card.component.html',
  styleUrls: ['./calendar-card.component.scss'],
  standalone: false,
})
export class CalendarCardComponent {
  @Output() calendarProviderSelected = new EventEmitter<string>();
  constructor(
    @Inject(FEATURE_MEETING_MICROSOFT_TEAMS_TOKEN)
    readonly featureMicrosoftTeamsEnabled$: Observable<boolean>,
  ) {}
  handleCalendarProvider(provider: string) {
    this.calendarProviderSelected.emit(provider);
  }
}
